<span>{{ this.valore == "-" ? this.valore : (this.valore | s1ItalianNumber) }}</span>